import { render, staticRenderFns } from "./IdeasSubmitted.vue?vue&type=template&id=671aaee8&scoped=true&"
import script from "./IdeasSubmitted.vue?vue&type=script&lang=js&"
export * from "./IdeasSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./IdeasSubmitted.vue?vue&type=style&index=0&id=671aaee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671aaee8",
  null
  
)

export default component.exports